const PLACEHOLDER_LABEL: Record<string, string> = {
  metal: 'Precious metal',
  precious_gemstone: 'Precious gem',
  semi_precious_gemstone: 'Semi-precious',
  mineral: 'Mineral specimen',
};

export function catalogPlaceholderLabel(haulCategory: string): string {
  return PLACEHOLDER_LABEL[haulCategory] ?? 'Material';
}

export function catalogPlaceholderClass(haulCategory: string): string {
  const key = haulCategory.replace(/[^a-z_]/g, '') || 'default';
  return `material-catalog-card__placeholder--${key}`;
}
